﻿require('slick-carousel');
(function ($) {
    $(document).ready(function () {
        let $logoCarousel = $('.carousel__slick');
        let $accreditationsCarousel = $('.carousel__accreditations');
        let $mmcCarousel = $('.carousel__mmc');

        const baseCarouselProps = {
            lazyLoad: 'ondemand',
            infinite: true,
            slidesToScroll: 1,
            slidesToShow: 1,
            touchThreshold: 10,
            draggable: true,
            lazyLoadBuffer: 1,
            focusOnSelect: true,
            arrows: false,
            dots: true,
            speed: 2000,
        }

        const handleSlickInit = ($carousel, options = null) => {
            let autoplay = $carousel.attr('data-slick-autoplay');
            let autoplaySpeed = $carousel.attr('data-slick-autoplay-speed');
            let additionalOptions = {
                autoplay,
                autoplaySpeed,
            }

            if (options) {
                additionalOptions = Object.assign({}, additionalOptions, options);
            }

            $carousel.slick(
                Object.assign({}, baseCarouselProps, additionalOptions)
            )
        }

        $.each($logoCarousel, function () { handleSlickInit($(this)) });

        $.each($accreditationsCarousel, function () {
            handleSlickInit($(this), {
                dots: false,
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true,
                responsive: [
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 2,
                        }
                    },

                    {
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 500,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    }
                ]
            })
        });

        $.each($mmcCarousel, function () {
            handleSlickInit($(this), {
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                appendArrows: $(this).parent().find('.carousel__mmc-navigation')
            })
        });
    });
})(jQuery);